import { UniformGallery } from '@/model';
import {
  GetMediaUniformGalleryByIdResponse,
  GetMediaUniformGalleryItemResponse,
  GetMediaUniformGalleryResponse,
  PostMediaUniformGalleryResponse,
  PutMediaUniformGalleryResponse,
} from '@/services/response/uniform-gallery';

export class UniformGalleryConverter {
  static toDomainFromGetItemResponse(response: GetMediaUniformGalleryItemResponse): UniformGallery {
    return {
      uuid: response.uuid,
      status: response.status,
      image_url: response.image_url,
      credit: response.credit,
      url: response.url,
      title: response.title,
      order: response.order,
      season_uuid: response.season_uuid,
      season_title: response.season_title,
      business_unit_uuid: response.business_unit_uuid,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPaginatedResponse(response: GetMediaUniformGalleryResponse): UniformGallery[] {
    return response.data.map(UniformGalleryConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromPostResponse(response: PostMediaUniformGalleryResponse): UniformGallery {
    return {
      uuid: response.uuid,
      status: response.status,
      image_url: response.image_url,
      url: response.url,
      title: response.title,
      order: response.order,
      credit: response.credit,
      season_uuid: response.season_uuid,
      season_title: response.season_title,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromByIdResponse(response: GetMediaUniformGalleryByIdResponse): UniformGallery {
    return {
      uuid: response.uuid,
      status: response.status,
      image_url: response.image_url,
      url: response.url,
      title: response.title,
      order: response.order,
      season_uuid: response.season_uuid,
      credit: response.credit,
      season_title: response.season_title,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutMediaUniformGalleryResponse): UniformGallery {
    return {
      uuid: response.uuid,
      status: response.status,
      credit: response.credit,
      image_url: response.image_url,
      url: response.url,
      title: response.title,
      order: response.order,
      season_uuid: response.season_uuid,
      season_title: response.season_title,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
